import { SET_USER, SHOW_LOGIN_MODAL, RESET_PASSWORD_SUCCESS } from "../actions/actionType";

const INITIAL_STATE = {
  user: null,
};

const useReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        user: action.user,
      }
    case SHOW_LOGIN_MODAL:
      return {
        ...state,
        showLogin: action.show,
      }
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordStatus: action.restPwdStatus,
      }
    default:
      return state;
  }
};

export default useReducer;
